<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="bg-gerund-color pt-227 pb-100">
    <ShippingDeliveryPolicy />
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import ShippingDeliveryPolicy from "../components/PrivacyPolicy/ShippingDeliveryPolicy.vue";

export default defineComponent({
  name: "ShippingDeliveryPolicyPage",
  components: {
    MainNavbar,
    MainFooter,
    ShippingDeliveryPolicy,
  },
});
</script>
